import { Component } from '@angular/core';
import { ToolbarComponent } from '../../../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../../../core/layout/components/footer/footer.component';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [ToolbarComponent, FooterComponent],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent {
  onCardClick(event: Event, url: string, target?: string) {
    // Prevenir que el click se propague al enlace interno
    event.preventDefault();

    if (url.startsWith('mailto:')) {
      // Para enlaces de email
      window.location.href = url;
    } else {
      // Para enlaces externos
      if (target === '_blank') {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  }
}
